import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./RelatedIncidentsList.module.css";
import { ChevronDown } from "react-ikonate";
import RelatedIncidentItem from "shared/RelatedIncidentItem";

/**
 * Interactive component.
 * Displays a list of incidents with a header.
 */
export function RelatedIncidentsList({ incidents, onClick }) {
  // Sort by most recent on render.
  const [sortedIncidents, setSortedIncidents] = useState(
    [...incidents].sort(
      (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
    )
  );
  const [sortingFilter, setSortingFilter] = useState("Date Created");
  const [isAsc, setIsAsc] = useState(false);

  /**
   * Stores the object property names with the header names.
   */
  const properties = {
    number: "Incident #",
    status: "Status",
    type: "Type",
    severity: "Severity",
    dateCreated: "Date Created",
  };

  /**
   * Sort list by property when the sort filter changes.
   */
  const handleSort = (_sortFilter) => {
    const newList = incidents.sort((a, b) => {
      const property = Object.keys(properties).find(
        (key) => properties[key] === _sortFilter
      );

      const result =
        _sortFilter === "Severity" || _sortFilter === "Incident #"
          ? a[property].replace(/\D/g, "") - b[property].replace(/\D/g, "")
          : _sortFilter === "Date Created"
          ? new Date(b[property]) - new Date(a[property])
          : a[property].localeCompare(b[property]);
      return result;
    });

    setSortedIncidents(newList);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {["Incident #", "Status", "Type", "Severity", "Date Created"].map(
          (header, index) => (
            <div
              className={styles.button}
              key={index}
              type="button"
              onClick={() => {
                if (sortingFilter === header) {
                  // Reverse list if sort filter doesn't change.
                  setSortedIncidents(sortedIncidents.reverse());
                  setIsAsc(!isAsc);
                } else {
                  handleSort(header);
                  setIsAsc(false);
                  setSortingFilter(header);
                }
              }}
            >
              {header}
              <div
                className={classNames(styles.icon, {
                  [styles.flip]: sortingFilter === header && isAsc,
                })}
              >
                <ChevronDown width={15} height={15} />
              </div>
            </div>
          )
        )}
      </div>
      {incidents.length === 0 ? (
        <div className={styles.noIncidents}>No Related Incidents</div>
      ) : (
        sortedIncidents.map((item, index) => (
          <div key={index}>
            <RelatedIncidentItem
              index={index}
              IncidentDetails={item}
              onClick={onClick}
              onIboClick={() => alert("TODO: onIboClick called")}
            />
          </div>
        ))
      )}
    </div>
  );
}

RelatedIncidentsList.propTypes = {
  /**
   * Array of objects with the incident details.
   */
  incidents: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string,
      status: PropTypes.string,
      type: PropTypes.string,
      severity: PropTypes.string,
      iboNum: PropTypes.string,
      caseOwner: PropTypes.string,
      dateCreated: PropTypes.string,
    })
  ),
};
